<template>
  <div class="w-full">
    <v-form
      ref="ambassadorForm"
      v-model="isFormValid"
      @change="error = ''"
    >
      <v-row>
        <v-text-field
          id="contact_person_system_firstname"
          ref="firstname"
          v-model.lazy="ambassadorData.firstname"
          outlined
          label="Vorname"
          placeholder="Max"
          :loading="isLoading.firstname"
          @input="(val) => update('firstname', val)"
        />
      </v-row>
      <v-row>
        <v-text-field
          ref="lastname"
          v-model.lazy="ambassadorData.lastname"
          outlined
          label="Nachname"
          placeholder="Makler"
          :loading="isLoading.lastname"
          @input="(val) => update('lastname', val)"
        />
      </v-row>
      <v-row>
        <PhoneField
          v-model="ambassadorData.phone"
          :loading="isLoading.phone"
          update-on-input
          @input="(val) => update('phone', val)"
        />
      </v-row>

      <v-row>
        <v-text-field
          ref="email"
          v-model.lazy="ambassadorData.email"
          type="email"
          outlined
          label="E-Mail"
          placeholder="info@max-makler.de"
          :rules="[rules.email]"
          :loading="isLoading.email"
          @input="(val) => update('email', val)"
        />
      </v-row>
    </v-form>
  </div>
</template>
<script>

import { email } from '@/lib/validation'
import featureNames from '@/lib/featureNames'
import PhoneField from '@/components/PhoneField.vue'

export default {
  components: { PhoneField },
  props: {
    ambassador: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      ambassadorData: { ...this.ambassador },
      debounceTimeout: null,
      spinnerTimeout: null,
      isLoading: {
        firstname: false,
        lastname: false,
        phone: false,
        email: false
      },
      isFormValid: false
    }
  },
  watch: {
    ambassador () {
      this.ambassadorData = { ...this.ambassador }
    }
  },
  created () {
    this.rules = { email }
    this.featureNames = featureNames
  },
  unmounted () {
    clearTimeout(this.spinnerTimeout)
    clearTimeout(this.debounceTimeout)
  },
  methods: {
    async update (name, value) {
      this.ambassadorData[name] = value
      clearTimeout(this.debounceTimeout)
      this.debounceTimeout = setTimeout(() => {
        this.isLoading[name] = true
        this.spinnerTimeout = setTimeout(async () => {
          const isFormValid = await this.$refs.ambassadorForm.validate()
          if (isFormValid) {
            this.$emit('saveSettings', { ...this.ambassadorData })
          }
          this.isLoading[name] = false
        }, 1000)
      }, 2000)
    }
  }
}
</script>
